import {Col, Row } from "react-bootstrap-v5"
import { MInput } from "../../../components/MInput/MInput"
import { Filtro } from "../Partial/Filtro";
import { tipoEmpresas } from "../tipos/tiposJs";
import { API_URL } from "../../../components/MConfig";

export const FiltroEmpresa = props => {

    return <Filtro novo={props.novo} chamada="filtrar_empresa" urlDownload="/revendedor/DownloadRelatorio">
        <Row>
            <Col className="col-md-6 col-12">
                <MInput
                    id="RevendedorId"         // <-- hidden terá id/name = RevendedorId
                    name="RevendedorId"
                    type="selectSearch"
                    title="Nome ou CPF"
                    url={API_URL + "/revendedor/ListarRevendedores"}
                    params={(v) => ({
                        TermoDaBusca: v,       // <-- o que foi digitado
                        PageNumber: 1,
                        PageSize: 200,
                    })}
                    onResult={(res) => {
                        const lista = Array.isArray(res)
                            ? res
                            : Array.isArray(res?.resultado)
                                ? res.resultado
                                : Array.isArray(res?.Resultado)
                                    ? res.Resultado
                                    : [];
                        return lista.map((z) => ({
                            value: z.id, // ID do revendedor
                            text: `${z.nome}${z.cpfCnpj ? " - " + z.cpfCnpj : ""}`,
                        }));
                    }}
                    useValueOnSearch={true}
                    onSelectItem={(opt) => {
                        // Aqui o MInput já preenche:
                        // - #RevendedorId (hidden) com opt.value (ID)
                        // - #RevendedorId_text (visível) com opt.text
                        // Se quiser filtrar imediatamente pela tabela:
                        // fire.call('filtrar_empresa', { RevendedorId: opt.value });
                        console.log("Selecionado (ID):", opt.value, "Label:", opt.text);
                    }}
                />
            </Col>
            <Col className="col-md-2">
                <MInput
                    type="date"
                    id="DataCadastroInicio"
                    title="Período Início" />
            </Col>
            <Col className="col-md-2">
                <MInput
                    id="DataCadastroFim"
                    type="date"
                    title="Período Fim" />
            </Col>
            <Col className="col-md-2">
                <MInput
                    id="SituacaoId"
                    type="select"
                    title="Situação"
                    default="Todos"
                    data={props.situacaoEmpresa}
                    onResult={res => res.map(z => ({ value: z.id, text: z.nome }))}
                />
            </Col>
            <Col className="col-md-2">
                <MInput type="select" id="tipoCadastro" data={tipoEmpresas} title="Tipo Cadastro" />
            </Col>
        </Row>
    </Filtro>
}